import BasePage from "../modules/basePage";

import "../modules/components/progressBar/horizontal"
import "../modules/components/progressBar/circular"
import "../modules/components/timer/countdown"
import "../modules/components/iframe/iframe"
import "../modules/components/video/video"
import "../modules/components/sliders/imageSlider"
import "../modules/components/links/links"
import "../modules/components/icon/icon"
import "../modules/components/iconAndText/iconAndText"
import "../modules/components/sliders/contentSlider"
import "../modules/components/forms/contactFrom"
import "../modules/components/navigation/navigationFE"
import "../modules/components/list/list"
import "../modules/components/buttons/buttons"
import "../modules/components/gallery/nanoGallery"

import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse';
class Production extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        Alpine.plugin(collapse);
        Alpine.start();
    }
}

new Production();
